/**
 * 로그인 없이 열리는 화면의 주소 머리(2026-10-30). KOL 이 링크로 여는 영상 피드백 페이지.
 * 앱 시작 때 부르는 요청(환율 등)이 로그인 없이 401 을 받아도, 이 주소에서는 로그인 화면으로 보내지 않는다
 * (보내면 KOL 이 링크를 열어도 로그인 화면이 떴다 — 배포 뒤 점검에서 발견).
 */
export const PUBLIC_PATH_PREFIXES = ['/kol-draft/'];

export const isPublicPath = (pathname) => PUBLIC_PATH_PREFIXES.some((p) => String(pathname || '').startsWith(p));
